// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"f0890f120fa68a0a","node_modules_canvg_lib_index_es_js":"9b6e0215018aeac4"}[chunkId] + ".js";
};